import { BASE_URL } from "../../App";
import DynamicTable from '../Reusable/DynamicTable';
import CustomTextField from "../Reusable/Numerictext";
import CustomButton from "../Reusable/CustomButton";
//import { SelectNormal, SelectSearch, MultipleSelect } from './SelectBox';

import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";

import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, MenuItem } from '@mui/material';
import Switch from '@mui/material/Switch';
import Stack from '@mui/material/Stack';
import Swal from 'sweetalert2';
import axios from 'axios';
import { SelectSearch } from "../Reusable/SelectBox";


export default function UserCreateTable() {
    const navigate = useNavigate();
    const [branchlist, setBranch] = useState([]);
    const [usertype, setUserType] = useState([]);
    const [tableData, setTableData] = useState([]);

    const [isCreateUserPopupOpen, setCreateUserPopupOpen] = useState(false);
    const [isPasswordPopupOpen, setPasswordPopupOpen] = useState(false);
    const [isViewPopupOpen, setViewPopupOpen] = useState(false);
    const [editedRowData, setEditedRowData] = useState(null);
    const [editingRow, setEditingRow] = useState(null);
    const [PasswordRow, setPasswordRow] = useState(null);
    const [viewData, setViewData] = useState(null);

    // api sending data
    const token = localStorage.getItem("Token");
    const headers = { Authorization: `Bearer ${token}` };
    const group_code = localStorage.getItem("GROUP_CODE");
    const Branch_code = localStorage.getItem("BRANCH_CODE");
    const login_id = localStorage.getItem("LOGIN_ID");

    const fetchData = () => {
        axios.post(BASE_URL + '/usertablelist', { login_id: login_id, user_group: group_code, branch: Branch_code })
            // axios.post(BASE_URL + '/usertablelist', { login_id: "1234", user_group: "2", branch: "1613" })
            .then(response => {
                if (response.status === 200) {
                    setTableData(response.data.UserDetails);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    Swal.fire({
                        icon: "warning",
                        text: `No response received`
                    });
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: error.message
                    });
                }
            });
    };

    const UserType = () => {
        axios.post(BASE_URL + '/usergroup')

            .then(response => {
                if (response.status === 200) {
                    setUserType(response.data.Users);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    Swal.fire({
                        icon: "warning",
                        text: `No response received`
                    });
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: error.message
                    });
                }
            });
    };

    const BranchList = () => {
        axios.post(BASE_URL + '/branch')

            .then(response => {
                if (response.status === 200) {
                    setBranch(response.data);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    Swal.fire({
                        icon: "warning",
                        text: `No response received`
                    });
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: error.message
                    });
                }
            });
    };

    useEffect(() => {
        if (!login_id || !Branch_code) {
            Swal.fire({
                icon: "warning",
                text: 'Login Failed !'
            });
            localStorage.clear()
            navigate('/')
            navigate('/Login')
        } else {
            fetchData();
            UserType();
            BranchList();
        }
    }, []);

    const openCreateUserPopup = (rowData) => {
        setCreateUserPopupOpen(true);
        setEditedRowData(rowData);
    };

    const handlePasswordClick = (rowData) => {
        setViewData(rowData);
        setPasswordPopupOpen(true);
    };

    const handleViewEditClick = (rowData) => {
        setViewData(rowData);
        setViewPopupOpen(true);
    };

    const handleReload = () => {
        fetchData();
    }

    return (
        <>
            <DynamicTable data={tableData} onEditClick={openCreateUserPopup} onViewClick={handleViewEditClick} onPasswordClick={handlePasswordClick} />
            {isCreateUserPopupOpen && (
                <EditUserPopup
                    user={editedRowData}
                    branchlist={branchlist}
                    usertype={usertype}
                    setTableData={setTableData}
                    onClose={() => {
                        setCreateUserPopupOpen(false);
                        setEditedRowData(null);
                    }}
                    onSave={() => handleReload()}
                />
            )}
            {editingRow && (
                <EditUserPopup
                    user={editingRow.original}
                    setTableData={setTableData}
                    onClose={() => setEditingRow(null)}
                    onSave={() => handleReload()}
                />
            )}
            {isPasswordPopupOpen && (
                <PasswordPopup
                    data={viewData}
                    onClose={() => setPasswordPopupOpen(false)}
                />
            )}
            {isViewPopupOpen && (
                <ViewDataPopup
                    data={viewData}
                    onClose={() => setViewPopupOpen(false)}
                />
            )}
        </>
    );
}

const EditUserPopup = ({ user, onClose, branchlist, usertype, onSave }) => {
    const [errorMsg, setErrorMsg] = useState('');
    const [editedUser, setEditedUser] = useState({ ...user, ACTIVE: '1', });
    const isCreateMode = !user;

    const login_id = localStorage.getItem("LOGIN_ID");

    const handleCreateSubmit = async () => {

        if (!validateInput()) {
            return;
        }

        try {
            const createUserData = {
                login_id: editedUser.LOGINID,
                user_id: editedUser.USER_ID,
                user_name: editedUser.USER_NAME,
                branch_code: editedUser.BRANCH_CODE,
                password: editedUser.Password,
                email_id: editedUser.EMAIL_ID,
                active: editedUser.ACTIVE,
                user_group_code: editedUser.User_Type,
                user_login_id: login_id,
            };

            const response = await axios.post(BASE_URL + '/usertablecreate', createUserData);
            onClose();
            Swal.fire({
                icon: "success",
                text: 'User Create Successfully.!'
            }).then(() => {
                onSave();
            });
        } catch (error) {
            onClose();
            Swal.fire({
                icon: "warning",
                text: error.response.data.message
            });
        }
    };

    const handleSaveSubmit = async () => {

        if (!validateInput2()) {
            return;
        }

        try {
            const updateUserData = {
                login_id: editedUser.LOGINID,
                user_id: editedUser.USER_ID,
                user_login_id: login_id,
                branch_code: editedUser.BRANCH_CODE,
                email_id: editedUser.EMAIL_ID,
                active: editedUser.ACTIVE,
            };

            const response = await axios.post(BASE_URL + '/usertableupdate', updateUserData);
            onClose();
            Swal.fire({
                icon: "success",
                text: 'User Updated Successfully.!'
            }).then(() => {
                onSave();
            });
        } catch (error) {
            onClose();
            //console.error('Error updating user:', error.response.data.message);
            Swal.fire({
                icon: "warning",
                text: error.response.data.message
            });
        }
    };

    const User_Type = usertype ? usertype.map((type) => ({
        Value: type.USERGROUP_CODE,
        Label: type.DESCRIPTION,
    })) : [];

    const Branch_List = branchlist ? branchlist.map((type) => ({
        Value: type.CODE,
        Label: type.name,
    })) : [];

    const validateLoginId = (loginid) => {
        if (loginid) {
            const data = { login_id: loginid }
            axios.post(BASE_URL + '/validateloginid', data)
                .then(response => {
                    if (response.status === 200) {
                        if (response.data.login_id_count >= 1) {
                            setErrorMsg('Login Id Already Available!');
                        } else {
                            setErrorMsg('');
                        }
                    }
                })
                .catch(error => {
                    setErrorMsg('Login ID Validation Error!');
                });
        }
    }

    const validateInput = () => {
        if (isCreateMode) {
            if (!/^[a-zA-Z\s]+$/.test(editedUser.USER_NAME) || editedUser.USER_NAME === '') {
                setErrorMsg('User name should contain only letters');
                return false;
            }
        }

        if (editedUser.EMAIL_ID) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const isValidEmail = re.test(String(editedUser.EMAIL_ID).toLowerCase());
            if (!isValidEmail) {
                setErrorMsg("Invalid email address!");
                return false;
            }
        }
        
        if (!editedUser.USER_NAME || !editedUser.USER_ID || !editedUser.LOGINID || !editedUser.EMAIL_ID || !editedUser.BRANCH_CODE || (isCreateMode && !editedUser.Password)) {
            setErrorMsg("Please fill in all fields!");
            return false;
        }

        return true;
    };

    const validateInput2 = () => {
        if (editedUser.EMAIL_ID) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const isValidEmail = re.test(String(editedUser.EMAIL_ID).toLowerCase());
            if (!isValidEmail) {
                setErrorMsg("Invalid email address!");
                return false;
            }
        }
        
        if (!editedUser.EMAIL_ID || !editedUser.BRANCH_CODE) {
            setErrorMsg("Please fill in all fields!");
            return false;
        }

        return true;
    };

    return (
        <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth sx={{ justifyContent: 'center' }}>
            <DialogTitle><u><b>{user ? 'Edit User' : 'Create New User'}</b></u></DialogTitle>
            <DialogContent>
                {isCreateMode && (
                    <>
                        <div className='row'>
                            <div className="col">
                                <SelectSearch
                                    label="User Type"
                                    required={true}
                                    options={User_Type}
                                    value={editedUser.User_Type}
                                    onChange={(newValue) => setEditedUser({ ...editedUser, User_Type: newValue })}
                                />
                            </div>
                            <div className="col">
                                <CustomTextField
                                    label="User Name"
                                    required={true}
                                    name="username"
                                    value={editedUser.USER_NAME}
                                    onChange={(e) => setEditedUser({ ...editedUser, USER_NAME: e.target.value })}
                                // onChange={(e) => {
                                //     const username = e.target.value;
                                //     if (/^[a-zA-Z\s]+$/.test(username) || username === '') {
                                //         setEditedUser({ ...editedUser, USER_NAME: username });
                                //         setErrorMsg('');
                                //     } else {
                                //         setErrorMsg('User name should contain only letters');
                                //     }
                                // }}
                                />
                            </div>
                        </div>
                    </>
                )}
                <div className='row'>
                    <div className="col">
                        {isCreateMode ? (
                            <CustomTextField
                                label="User Id"
                                required={true}
                                name="userid"
                                value={editedUser.USER_ID}
                                onChange={(e) => setEditedUser({ ...editedUser, USER_ID: e.target.value })}
                            />
                        ) : (
                            <CustomTextField
                                label="User Id"
                                name="userid"
                                value={editedUser.USER_ID}
                                disabled
                                onChange={(e) => setEditedUser({ ...editedUser, USER_ID: e.target.value })}
                            />
                        )}
                    </div>
                    <div className="col">
                        {isCreateMode ? (
                            <CustomTextField
                                label="Login Id"
                                required={true}
                                name="loginid"
                                value={editedUser.LOGINID}
                                // onChange={(e) => setEditedUser({ ...editedUser, LOGINID: e.target.value })}
                                onChange={(e) => {
                                    const loginid = e.target.value;
                                    if (!validateLoginId(loginid)) {
                                        setEditedUser({ ...editedUser, LOGINID: loginid });
                                    }
                                }}
                            />
                        ) : (
                            <CustomTextField
                                label="Login Id"
                                name="loginid"
                                value={editedUser.LOGINID}
                                disabled
                                onChange={(e) => setEditedUser({ ...editedUser, LOGINID: e.target.value })}
                            />
                        )}
                    </div>
                </div>
                <div className='row'>
                    <div className="col">
                        <CustomTextField
                            label="Email"
                            required={isCreateMode ? true : false}
                            name="email"
                            value={editedUser.EMAIL_ID}
                            onChange={(e) => setEditedUser({ ...editedUser, EMAIL_ID: e.target.value })}
                        />
                    </div>
                </div>
                {isCreateMode && (
                    <div className='row'>
                        <div className="col">
                            <CustomTextField
                                label="Password"
                                required={true}
                                name="pass"
                                value={editedUser.Password}
                                onChange={(e) => setEditedUser({ ...editedUser, Password: e.target.value })}
                            />
                        </div>
                    </div>
                )}
                <div className='row'>
                    <div className="col">
                        <SelectSearch
                            label="Branch"
                            required={isCreateMode ? true : false}
                            options={Branch_List}
                            value={editedUser.BRANCH_CODE}
                            onChange={(newValue) => setEditedUser({ ...editedUser, BRANCH_CODE: newValue })}
                        />
                    </div>
                </div>
                {isCreateMode && (
                    <div className='row'>
                        <div className="col mt-2">
                            <label>Active Status</label>
                            <Switch
                                // checked={editedUser.ACTIVE === "1"}
                                checked={editedUser.ACTIVE === "1"}
                                onChange={(e) => setEditedUser({ ...editedUser, ACTIVE: e.target.checked ? "1" : "0" })}
                                name="active_switch"
                                color="primary"
                            />
                        </div>
                    </div>
                )}
            </DialogContent>
            {errorMsg &&
                <DialogContent>
                    <center>
                        <span style={{ color: 'red' }}>* {errorMsg}</span>
                    </center>
                </DialogContent>
            }
            <DialogActions sx={{ justifyContent: 'center' }}>
                <Stack direction="row" spacing={2} sx={{ width: '100%', maxWidth: '400px' }}>
                    <CustomButton
                        label={(isCreateMode ? 'Create' : 'Save')}
                        onClick={isCreateMode ? handleCreateSubmit : handleSaveSubmit}
                        variant="outlined"
                        fullWidth
                        width="200px"
                    />
                    <CustomButton
                        label="Cancel"
                        onClick={onClose}
                        variant="outlined"
                        color="error"
                        fullWidth
                        width="200px"
                    />
                </Stack>
            </DialogActions>
        </Dialog >
    );
};

const ViewDataPopup = ({ data, onClose }) => {
    return (
        <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth sx={{ justifyContent: 'center' }}>
            <DialogTitle><u><b>View User</b></u></DialogTitle>
            <DialogContent>
                <div className='row'>
                    <div className='col'>
                        <CustomTextField
                            label="Login Id"
                            name="Login_Id"
                            value={data.LOGINID}
                            InputProps={{ readOnly: true }}
                        />
                    </div>
                    <div className='col'>
                        <CustomTextField
                            label="Username"
                            name="Username"
                            value={data.USER_NAME}
                            InputProps={{ readOnly: true }}
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col'>
                        <CustomTextField
                            label="Email"
                            name="Email"
                            value={data.EMAIL_ID}
                            InputProps={{ readOnly: true }}
                        />
                    </div>
                    <div className='col'>
                        <CustomTextField
                            label="Branch"
                            name="Branch"
                            value={data.BRANCH_CODE}
                            InputProps={{ readOnly: true }}
                        />
                    </div>
                </div>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center' }}>
                <Stack direction="row" spacing={2} sx={{ width: '100%', maxWidth: '400px' }}>
                    <CustomButton
                        label="Close"
                        onClick={onClose}
                        variant="outlined"
                        fullWidth
                        width="400px"
                    />
                </Stack>
            </DialogActions>
        </Dialog>

    );
};

const PasswordPopup = ({ data, onClose }) => {
    const [editedPassword, setEditedPassword] = useState({ oldPassword: '', newPassword: '', confirmPassword: '' });
    const [errorMsg, setErrorMsg] = useState('');
    const login_id = localStorage.getItem("LOGIN_ID");

    const handlePasswordUpdate = async () => {

        setErrorMsg();
        if (!validatePasswords()) {
            return;
        }

        try {
            const updatePasswordData = {
                login_id: login_id,
                user_id: data.USER_ID,
                branch_code: data.BRANCH_CODE,
                user_name: data.USER_NAME,
                type: data.USERTYPE,
                new_password: editedPassword.newPassword,
                confirm_password: editedPassword.confirmPassword,
            };

            const response = await axios.post(BASE_URL + '/changepassword', updatePasswordData);

            onClose();
            Swal.fire({
                icon: "success",
                text: 'Password Updated Successfully.!'
            });
        } catch (error) {
            setErrorMsg(error.response.data.message);
        }
    };

    const validatePasswords = () => {
        if (!editedPassword.newPassword || !editedPassword.confirmPassword) {
            setErrorMsg("Please fill in all fields!");
            return false;
        }

        if (editedPassword.newPassword !== editedPassword.confirmPassword) {
            setErrorMsg("password and confirm password do not match");
            return false;
        }

        if (!validatePasswordStrength(editedPassword.newPassword)) {
            setErrorMsg('Password must contain at least one Uppercase, one Lowercase, one number, and one special character.');
            return false;
        }

        if (!validatePasswordStrength(editedPassword.confirmPassword)) {
            setErrorMsg('Password must contain at least one Uppercase, one Lowercase, one number, and one special character.');
            return false;
        }

        return true;
    };
	
	const validatePasswordStrength = (input) => {
        const hasUpperCase = /[A-Z]/.test(input);
        const hasLowerCase = /[a-z]/.test(input);
        const hasNumber = /[0-9]/.test(input);
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(input);

        return hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar;
    };

    return (
        <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth sx={{ justifyContent: 'center' }}>
            <DialogTitle><u><b>Password Change</b></u></DialogTitle>
            <DialogContent>
                {/* <div className='row'>
                    <div className='col'>
                        <CustomTextField
                            label="Old-Password"
                            name="Old-password"
                            InputProps={{ readOnly: true }}
                            value={data.PASSWORD}
                            onChange={(e) => setEditedPassword({ ...editedPassword, oldPassword: e.target.value })}
                        />
                    </div>
                </div> */}
                <div className='row'>
                    <div className='col'>
                        <CustomTextField
                            label="New-password"
                            name="New-Password"
                            type="password"
                            value={editedPassword.newPassword}
                            onChange={(e) => setEditedPassword({ ...editedPassword, newPassword: e.target.value })}
                        />
                    </div>
                    <div className='col'>
                        <CustomTextField
                            label="Confirm-password"
                            name="Confirm-Password"
                            type="password"
                            value={editedPassword.confirmPassword}
                            onChange={(e) => setEditedPassword({ ...editedPassword, confirmPassword: e.target.value })}
                        />
                    </div>
                </div>
                <div className="row mt-2">
                    <center>
                        {errorMsg && <span style={{ color: 'red' }}>* {errorMsg}</span>}
                    </center>
                </div>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center' }}>
                <Stack direction="row" spacing={2} sx={{ width: '100%', maxWidth: '400px' }}>
                    <CustomButton
                        label="Update"
                        onClick={handlePasswordUpdate}
                        variant="outlined"
                        fullWidth
                        width="200px"
                    />
                    <CustomButton
                        label="Cancel"
                        onClick={onClose}
                        variant="outlined"
                        color="error"
                        fullWidth
                        width="200px"
                    />
                </Stack>
            </DialogActions>
        </Dialog>

    );
};